import { routerReducer } from '@ngrx/router-store';

import { entityMapViewReducers } from 'app/entity-map-view/_state/entity-map-view.reducers';
import { EntityMapViewState } from 'app/entity-map-view/_state/entity-map-view.state';
import {
  printButtonReducers, PrintButtonStateName
} from 'app/print-view/components/print-button/_state/print-buton-state';
import {
  responseSearchComponentContextReducers
} from 'field-shared/components/response-search/state/response-search.reducers';

import { accountReducers } from './account/account-reducers';
import { authReducers } from './auth/auth-reducers';
import { campaignContextReducers } from './campaign-context/campaign-context-reducers';
import { entityListPageReducers } from './entity/entity-list-page/entity-list-page.reducers';
import { EntityListPageStateKey } from './entity/entity-list-page/entity-list-page.state';
import {
  entityConnectionReducers
} from './entity/view-entity/entity-connections/entity-connection.reducers';
import {
  EntityConnectionStateName
} from './entity/view-entity/entity-connections/entity-connection.state';
import {
  entityInfoPageReducers
} from './entity/view-entity/entity-info-page/entity-info-page.reducers';
import {
  EntityInfoPageStateName
} from './entity/view-entity/entity-info-page/entity-info-page.state';
import { orgContextReducers } from './org-context/org-context-reducers';

export const reducers = {
  router: routerReducer,
  AuthState: authReducers,
  OrgContextState: orgContextReducers,
  CampaignContextState: campaignContextReducers,
  AccountState: accountReducers,
  ResponseSearchComponentState: responseSearchComponentContextReducers,
  [PrintButtonStateName]: printButtonReducers,
  [EntityMapViewState]: entityMapViewReducers,
  [EntityListPageStateKey]: entityListPageReducers,
  [EntityConnectionStateName]: entityConnectionReducers,
  [EntityInfoPageStateName]: entityInfoPageReducers
};
